import { defineStore } from "pinia";

export const useDemoStore = defineStore("erp", {
  persist: {
    enabled: true, //开启缓存
    strategies: [
      {
        // 缓存的模块名称
        key: '',
        // 保存位置，默认保存在sessionStorage
        storage: localStorage,
        // 缓存哪些状态
        // paths: ["state",'token']
        // 删除上一个
      }],
  },
  state: () => {
    return {
      state: true, //侧边栏(不在使用)
      context: 2, //0测试环境，1备用，2生产环境
      server: 'cn', //服务器
      userWorkState: 0,//工作状态(0:空闲,1:忙碌,2:暴躁,3:罢工)
      token: "",
      userMailbox: "", //邮箱
      UserGroupName: "", //用户昵称
      headSculpture: "", //头像
      userId: "",
      user_group_id: "", //用户组id
      company_id: '', //公司id
      user_uid: "",
      org_id: '', //组织id
      departmentInfo: {}, //部门信息
      missu_user_group_id: "", //按钮权限需要用到的id
      client_type: "",// 客户类型：0其他 1普通客户 2合作伙伴
      user_type: "", //用户账号类型，0外2内
      isSuperAdmin: "",  //0普通用户  1超级管理员  3管理员账号
      type: "", //用户类型，1超管，2销售，3采购，4客户
      role_type: '', //全部角色类型
      tabList: [], //标签
      routerList: [{}], //路由列表
      toROuter: '', //当前的路由位置
      powerList: {}, //按钮权限列表
      lang: "en-us", //国际化
      currency: 'CNY', //币种
      parities: 1,//汇率
      rateList: {},//汇率对象
      isRefresh: true,
      pageState: true,
      isRightMenu: false,
      rfqPage: 1, //区分当前询盘所在的页面
      qtnPage: 1, //区分当前报价所在的页面
      PurchaseQTNList: [],//采购报价的相关数据
      publicShow: false, //公开询盘列表切换
      personalShow: false, //个人询盘列表切换
      myRfqShow: false, // 我的询盘切换
      contactsRfqShow: false, // 客户询盘切换
      qtnPurchaseShow: false, //采购报价视图切换
      myQtnShow: false, //我的报价视图切换
      contactsQtn: false, //客户报价视图切换
      orderShow: false,//销售单切换
      pOrderShow: false,//采购单切换
      kanbanShow: false,//工单看板切换
      messageShow: 0,//消息切换
      workOrderShow: '发起单',
      discoverTabName: 'Hot',//探索tabs切换选项的name
      isAdding: true,//究竟是添加append策略还是编辑Edit策略，取决于isAdding
      strategyItem: {},//策略详情
      toggleView: true,//切换视图
      more: [],//更多
      rfqPurview: true, //询盘/报价按钮权限
      storePassword: '',// 存储密码
      socket: "",
      systemNotify: false,//系统消息通知
      shopCopyData: {},//商铺克隆消息
      user_host: "",//保存用户绑定的域名
      UnreadObj: {},//保存未读消息
      MSGData: {},//保存服务器发送的消息
      requestInterfaceSucceeded: true, // 接口请求成功
      accountId: -1, // 账户id
      otherUserId: -1, // 其他用户或下级的用户ID
      accountUsername: "", // 账户用户名
      signatureShow: false, // 插入签名按钮是否显示
      From: "", // 发件人
      codeKey: '', //解密key值
      RememberQuoteInfo: {//报价记住我的选择
        checked: false,
        val: []
      },
      MSGSendContent:'',//聊天发送的消息
    };
  },
  getters: {

  },
  actions: {
    changeState(newState) {
      this.state = newState;
    },
    changeContext(newContext) {
      this.context = newContext;
    },
    changeServer(newServer) {
      this.server = newServer;
    },
    changeToken(newToken) {
      this.token = newToken;
    },
    changeUsemame(newUserMailbox) {
      this.userMailbox = newUserMailbox;
    },
    changeName(newName) {
      this.UserGroupName = newName;
    },
    changeSculpture(newSculpture) {
      this.headSculpture = newSculpture;
    },
    changeClientType(newClientType) {
      this.client_type = newClientType
    },//客户类型
    changeUser_type(newUser_type) {
      this.user_type = newUser_type;
    },
    changeIsSuperAdmin(newIsSuperAdmin) {
      this.isSuperAdmin = newIsSuperAdmin;
    },
    changeType(newType) {
      this.type = newType;
    },
    changeRoleType(newType) {
      this.role_type = newType;
    },
    changeUser(newUser) {
      this.userId = newUser;
    },
    changeOrg_id(newOrgId) {
      this.org_id = newOrgId;
    },
    changeDeparInfo(newInfo) {
      this.departmentInfo = newInfo;
    },
    changeUser_uid(newUser_uid) {
      this.user_uid = newUser_uid;
    },
    changeGroup_id(newGroup_id) {
      this.user_group_id = newGroup_id;
    },
    changeCompanyId(newCompanyId) {
      this.company_id = newCompanyId;
    },
    changeUserGroupId(newGroupId) {
      this.missu_user_group_id = newGroupId;
    },
    changeTab(newTab) {
      this.tabList = newTab;
    },
    changeRouter(newRouter) {
      this.routerList = newRouter;
    },
    changenToROuter(newToROuter) {
      this.toROuter = newToROuter;
    },
    changePower(newPower) {
      this.powerList = newPower;
    },
    changeLang(newLang) {
      this.lang = newLang;
    },
    changeIsRefresh(newIs) {
      this.isRefresh = newIs;
    },
    changeCurrency(newCurrency) {
      this.currency = newCurrency;
    },
    changeParities(newParities) {
      this.parities = newParities;
    },
    changeRate(obj) {
      this.rateList = obj
    },
    changepageState(newState) {
      this.pageState = newState;
    },
    changeisRightMenu(newMenu) {
      this.isRightMenu = newMenu;
    },
    changeRfqPage(newRfqPage) {
      this.rfqPage = newRfqPage;
    },
    changeQtnPage(newQtnPage) {
      this.qtnPage = newQtnPage;
    },
    changePublic(newPublicShow) {
      this.publicShow = newPublicShow
    },
    changePersonal(newPersonalShow) {
      this.personalShow = newPersonalShow
    },
    changeMyRfq(newMyRfq) {
      this.myRfqShow = newMyRfq
    },
    changeContactsRfq(newContactsRfq) {
      this.contactsRfqShow = newContactsRfq
    },
    changeQtnPurchase(newQtnPurchase) {
      this.qtnPurchaseShow = newQtnPurchase
    },
    changeMyQtnShow(newMyQtn) {
      this.myQtnShow = newMyQtn
    },
    changeContactsShow(newContacts) {
      this.contactsQtn = newContacts
    },
    changeOrderShow(newOrderShow) {
      this.orderShow = newOrderShow
    },
    changepOrderShow(newPorderShow) {
      this.pOrderShow = newPorderShow
    },
    changepKanbanShow(newKanbanShow) {
      this.kanbanShow = newKanbanShow
    },
    changepMessageShow(newMessageShow) {
      this.messageShow = newMessageShow
    },
    changeWorkOrderShow(newWorkOrder) {
      this.workOrderShow = newWorkOrder
    },
    changeToggleView(bool) {
      this.toggleView = bool;
    },
    changeDiscoverTabName(str) {
      this.discoverTabName = str;
    },//切换选项卡
    changeIsAdding(newIsAdding) {
      this.isAdding = newIsAdding;
    },
    changeStrategyItem(newObj) {
      this.strategyItem = JSON.parse(JSON.stringify(newObj))
    },
    changeMore(newMore) {
      this.more = newMore;
    },
    changeRfqPurview(show) {
      this.rfqPurview = show;
    },
    changeRequestInterfaceFailed(data) {
      this.requestInterfaceSucceeded = data;
    },
    changeCodeKey(key){
      this.codeKey = key
    }
  },
});
